module.exports = __webpack_public_path__ + "img/Logos-Footer-CAV.37514230.png";